import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { i18n } from './i18n';
import './styles/tailwind.css';
import { registerSW } from './pwa/registerSW';
import { useThemeStore } from './stores/theme';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(i18n);

// Apply the persisted theme before mount so the first paint matches preference.
useThemeStore().init();

app.mount('#app');

registerSW();
